import { render, staticRenderFns } from "./m01b-user-info.vue?vue&type=template&id=3373b4d2&scoped=true"
import script from "./m01b-user-info.vue?vue&type=script&lang=js"
export * from "./m01b-user-info.vue?vue&type=script&lang=js"
import style0 from "./m01b-user-info.vue?vue&type=style&index=0&id=3373b4d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3373b4d2",
  null
  
)

export default component.exports